<form [formGroup]="formGroup" class="flex flex-col w-full">
  <app-expandable-section-box
    [title]="title"
    [iconClass]="iconClass"
    [isExpandedByDefault]="isExpandedByDefault"
    [isExpandable]="isExpandable"
  >
    <div
      class="flex flex-col p-4 gap-y-1"
      data-testid="checkbox-list"
      expandedContent
    >
      <ng-container *ngFor="let item of metadata; index as i">
        <mat-checkbox
          class="hover:text-project-2100 hover:underline"
          color="primary"
          [formControlName]="item.id"
          [name]="item.id"
          (change)="onOptionChange($event)"
          [title]="
            !formGroup.valid
              ? 'Please check this box if you want to proceed.'
              : ''
          "
          data-testid="checkbox-list-item"
        >
          {{ this.memoMetadataMap[item.id]?.label ?? getControlLabel(item.id) }}
        </mat-checkbox>
      </ng-container>
    </div>

    <div
      class="flex flex-col w-full py-4 pr-3 m-0 bg-project-2200"
      *ngIf="selectedItems?.length"
      data-testid="preview"
      notExpandedContent
    >
      <h3 class="mx-0 my-2 text-xs font-bold uppercase text-project-2300">
        Preview
      </h3>
      <div
        class="flex flex-col text-xs py-0 px-2 gap-y-[0.3rem]"
        data-testid="preview-list"
      >
        <ng-container *ngFor="let selectedItem of selectedItems">
          <a
            class="py-[1px] text-project-500 font-bold cursor-pointer underline"
            [href]="selectedItem.previewUrl"
            disabled="selectedItem.previewUrl"
            *ngIf="selectedItem.previewUrl"
            target="_blank"
            >{{ selectedItem.label }}</a
          >
          <p
            class="py-[1px] text-project-2400"
            *ngIf="!selectedItem.previewUrl"
          >
            {{ selectedItem.label }}
          </p>
        </ng-container>
      </div>
    </div>
  </app-expandable-section-box>
</form>
